import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import Logo from './Logo';
import ContactModal from './ContactModal';
import './Footer.css';

const Footer = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [searchParams] = useSearchParams();
  // Mesafeli Satış Sözleşmesi ve İptal/İade sayfaları EN'i destekliyor;
  // TransMeet EN akışından bu sayfalara gelen kullanıcı footer'dan da EN'de kalsın.
  const legalSuffix = searchParams.get('lang') === 'en' ? '?lang=en' : '';

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__row">
          <Link to="/" className="footer__logo">
            <Logo size="small" showDomain />
          </Link>

          <div className="footer__links">
            <a href="/yapay-zeka-is-bulsun" className="footer__link">Yapay Zeka İş Bulsun</a>
            <a href="/hakkimizda" className="footer__link">Hakkımızda</a>
            <a href="/gizlilik" className="footer__link">Gizlilik Politikası</a>
            <a href="/kullanim-kosullari" className="footer__link">Kullanım Koşulları</a>
            <a href={`/mesafeli-satis-sozlesmesi${legalSuffix}`} className="footer__link">Mesafeli Satış Sözleşmesi</a>
            <a href={`/iptal-iade${legalSuffix}`} className="footer__link">Teslimat ve İade Şartları</a>
            <button className="footer__link footer__link--btn" onClick={() => setIsContactOpen(true)}>İletişim</button>
          </div>

          <span className="footer__phone"><Phone size={12} /> 0850 307 80 61</span>
        </div>

        <div className="footer__payments">
          <img
            src="/iyzico-logo-band.svg"
            alt="iyzico ile öde: Visa, Mastercard, Troy ve American Express ile güvenli ödeme"
            className="footer__payments-band"
            loading="lazy"
            width="429"
            height="32"
          />
        </div>

        <p className="footer__disclaimer">
          <strong>Hukuki Bilgilendirme:</strong> isBulsun.com bir Özel İstihdam Bürosu veya İş
          İlanı / İşe Yerleştirme Aracılık Platformu değildir. Sitemiz, kullanıcıların kendi
          yönlendirmeleriyle iş arama süreçlerini kolaylaştıran, form taslakları hazırlayan ve
          ilan analizi sunan bir yazılım (SaaS) platformudur. Platformumuz herhangi bir işe
          yerleştirme taahhüdü veya vize/çalışma izni garantisi vermez.
        </p>

        <div className="footer__bottom">
          <p>&copy; 2026 isBulsun.com - Tüm hakları saklıdır.</p>
          <span className="footer__address"><MapPin size={12} /> Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer / İstanbul</span>
        </div>
      </div>
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </footer>
  );
};

export default Footer;
